export default __webpack_public_path__ + "static/media/5.b8e41bc9.png";